import axiosPost from "../axiosPost";

export const horarioUpd = async ({
    gateHorarioId,
    gateHorarioNombre,
    gateHorarioDescripcion = null,
    gateHorarioVersion,
    gateHorarioCod
}, credentials) => {
    const body = {
        service: "GateHorarioUpd",
        params: {
            gateHorarioId,
            gateHorarioNombre,
            gateHorarioDescripcion,
            gateHorarioVersion,
            gateHorarioCod
        },
    };

    return await axiosPost(body, credentials);
};
